import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Radio } from '@/shared/uikitV2/Radio';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  overflow: auto;

  ${media.md}, ${breakpoints.sm} {
    padding: 16px;
    flex: 1;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column-reverse;
    gap: 8px;

    button {
      width: 100%;
    }
  }
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
  overflow: auto;

  > div {
    padding-bottom: 24px;
  }

  .ant-input-data-count,
  .ant-input-show-count-suffix {
    font-size: 12px;
    color: ${COLORS.systemDark200};
    line-height: 16px;
    position: absolute;
    bottom: -20px;
    right: 0;
  }
`;

export const CasePreview = styled.label`
  display: block;
  position: relative;
  border-radius: 12px;
  padding: 16px;
  height: fit-content;
  width: fit-content;
`;

export const RadioStyled = styled(Radio)`
  position: absolute;
  top: 6px;
  right: 6px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  gap: 16px;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
